import { BlockContainer } from "Components/elements/RVFlow/Shared/FlowNodeBlocks/BlockContainer/BlockContainer";
import { BlockContent } from "Components/elements/RVFlow/Shared/FlowNodeBlocks/BlockContent/BlockContent";
import { BlockTitle } from "Components/elements/RVFlow/Shared/FlowNodeBlocks/BlockTitle/BlockTitle";
import {
    getJourneyNodeContentSummary,
    getJourneyNodeIcon,
    getJourneyNodeTypeConfig,
} from "Components/elements/RVFlow/Shared/JourneyNodePresentation";
import { NodeType } from "Types/Journey";

// TODO: update type to import type { SharedBlockProps } from "Components/elements/RVFlow/RVFlowTypes";
// and follow up updateContactBlock or the IVR blocks work
const BLOCK_VARIANT = getJourneyNodeTypeConfig(NodeType.Webhook).variant;
const BLOCK_ICON = getJourneyNodeIcon(NodeType.Webhook);

export function WebhookActionBlock({ data }: { data?: any }): JSX.Element {
    const isActive = data?.webhookName || data?.empty;

    return (
        <BlockContainer variant={BLOCK_VARIANT} icon={BLOCK_ICON}>
            <BlockTitle nodeData={data} fallBackDisplay={data?.empty ? "Action" : "Webhook"}></BlockTitle>
            <BlockContent isActive={isActive}>{getJourneyNodeContentSummary(NodeType.Webhook, data)}</BlockContent>
        </BlockContainer>
    );
}
